import { STORAGE_KEY } from '@/constants/storage';
import { $http, $httpWP } from '@/plugins/common/http';

export const getWPHostingList = (query) => {
    return $http.get('/user/wordpress-hosting', {
        params: {
            ...query,
        },
    });
};

export const getWPHostingStatistics = () => {
    return $http.get('/user/wordpress-hosting/statistics');
};

export const setAutoRenew = (id, autoRenew) => {
    return $http.patch('user/wordpress-hosting/' + id + '/auto-renew', {
        autoRenew: autoRenew,
    });
};

export const getWPHostingById = (id) => {
    return $http.get(`/user/wordpress-hosting/${id}`);
};

export const getWPManagementDetail = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}`);
};

export const getWPManagementThemes = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/themes`);
};

export const getWPManagementPlugins = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/plugins`);
};

export const updateConfig = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/configurations`, data);
};

export const updateWPServerName = (packageId, data) => {
    return $http.patch(
        `/user/wordpress-hosting/${packageId}/server-name`,
        data
    );
};

export const updateWPWebsiteName = (id, data) => {
    return $httpWP.patch(`/user/wordpress-hosting/${id}/website-name`, data);
};

export const getInstalledThemes = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/themes`);
};

export const deleteTheme = (id, data) => {
    return $httpWP.delete(`/user/wordpress-hosting/${id}/themes`, { data });
};

export const activateTheme = (id, data) => {
    return $httpWP.patch(`/user/wordpress-hosting/${id}/themes`, data);
};

export const upgradeTheme = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/themes/upgrade`, data);
};

export const searchThemes = (id, params) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/themes/search`, {
        params,
    });
};

export const installTheme = (id, data) => {
    return $httpWP.put(`/user/wordpress-hosting/${id}/themes`, data);
};

export const uploadWPTheme = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/themes/upload`, data);
};

export const backupInstallation = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/backups`, data);
};

export const backupInstallationStatus = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/backups/status`, data);
};

export const listBackups = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/backups`);
};

export const downloadBackup = (id, options) => {
    return $httpWP.get(
        `/user/wordpress-hosting/${id}/backups/download`,
        options
    );
};

export const restoreBackup = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/restore`, data);
};

export const restoreBackupStatus = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/restore/status`, data);
};

export const deleteBackup = (id, query) => {
    return $httpWP.delete(`/user/wordpress-hosting/${id}/backups`, {
        params: {
            ...query,
        },
    });
};

export const searchPlugins = (id, params) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/plugins/search`, {
        params,
    });
};

export const installPlugin = (id, data) => {
    return $httpWP.put(`/user/wordpress-hosting/${id}/plugins`, data);
};

export const uploadWPPlugin = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/plugins/upload`, data);
};

export const upgradePluginVersion = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/plugins/upgrade`, data);
};

export const changePluginActivated = (id, data) => {
    return $httpWP.patch(`/user/wordpress-hosting/${id}/plugins`, data);
};

export const deletePlugin = (id, data) => {
    return $httpWP.delete(`/user/wordpress-hosting/${id}/plugins`, { data });
};

export const getWPAdminURL = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/sign-on-url`);
};

export const changeAutoRenewStatus = (packageId, autoRenew) => {
    return $http.patch(`/user/wordpress-hosting/${packageId}/auto-renew`, {
        autoRenew,
    });
};

export const getPopularWPThemes = (data) => {
    return $http.post('/products/wordpress-hosting/themes', data);
};
export const getPopularWPPlugins = (data) => {
    return $http.post('/products/wordpress-hosting/plugins', data);
};

export const reinstallWP = (id, data) => {
    return $http.post(`/user/wordpress-hosting/${id}/reinstall`, data);
};

export const generateWordpressFreeDomain = () => {
    return $httpWP.get('/domains/wordpress-free-domain');
};

export const updateMainDomainWP = (id, data) => {
    return $http.patch(`/user/wordpress-hosting/${id}/domain`, data);
};

export const getFTPAccount = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/ftp-accounts/active`, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};

export const generateFTPAccount = (id, data) => {
    return $httpWP.put(`/user/wordpress-hosting/${id}/ftp-accounts`, data, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};

export const revokeFTPAccount = (id, accountId) => {
    return $httpWP.delete(
        `/user/wordpress-hosting/${id}/ftp-accounts/${accountId}`
    );
};

export const getSecurityConfigs = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/ssl`);
};

export const changeSslStatus = (id, data) => {
    return $httpWP.patch(`/user/wordpress-hosting/${id}/ssl`, data);
};

export const changeSecureRedirect = (id, data) => {
    return $httpWP.patch(`/user/wordpress-hosting/${id}/secure-redirect`, data);
};

export const getDBAccount = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/db-accounts/active`, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};

export const generateDBAccount = (id, data) => {
    return $httpWP.put(`/user/wordpress-hosting/${id}/db-accounts`, data, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};

export const revokeDBAccount = (id, accountId) => {
    return $httpWP.delete(
        `/user/wordpress-hosting/${id}/db-accounts/${accountId}`
    );
};

export const upgradeWPVersion = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/upgrade`, data);
};

export const upgradeWPVersionStatus = (id, data) => {
    return $httpWP.post(`/user/wordpress-hosting/${id}/upgrade/status`, data);
};

export const getDiskQuota = (id) => {
    return $httpWP.get(`/user/wordpress-hosting/${id}/disk-quota`);
};

export const regeneratePrimaryDomain = (id) => {
    return $http.patch(`/user/wordpress-hosting/${id}/regenerate-domain`);
};

export const sendOTPChangePassword = (query) => {
    return $http.get('user/otp/change-wordpress-hosting-password', {
        params: {
            ...query,
        },
    });
};

export const changePassword = (packageId, data) => {
    return $http.patch(
        'user/wordpress-hosting/' + packageId + '/password',
        data
    );
};

export const changeSslCertificate = (id, data) => {
    return $httpWP.patch(`user/wordpress-hosting/${id}/ssl-certificate`, data, {
        headers: { [STORAGE_KEY.ENCRYPTION]: true },
    });
};
